import dayjs from "dayjs";

import {httpDelete, httpGet, httpPost, httpPostFile, httpPut} from "./http";
import {formatDate, formatTimestamp, formatTimestampWithoutSeconds} from "./misc";

const carsUrl = window.env.BACKEND_API_URL + "/cars";

const colours = ['Black', 'Blue', 'Brown', 'Gold', 'Grey', 'Green', 'Orange', 'Pink', 'Purple', 'Red', 'Silver', 'White', 'Yellow'];

const buildCarDescription = (car) => {
    let description = '';

    if (car.year) description += car.year + ' ';
    if (car.colour) description += car.colour + ' ';
    if (car.make) description += car.make + ' ';
    if (car.model) description += car.model + ' ';

    if (description === '') description = 'N/A';

    return description.trim();
};

//region CRUD
const addCar = ({vin, make, model, year, seats, colour, number, licence_plate, friendly_name, rate_class}, signal) => {
    const body = {number};

    if (vin !== undefined) body['vin'] = vin;
    if (make !== undefined) body['make'] = make;
    if (model !== undefined) body['model'] = model;
    if (year !== undefined) body['year'] = year;
    if (seats !== undefined) body['seats'] = seats;
    if (colour !== undefined) body['colour'] = colour;
    if (licence_plate !== undefined) body['licence_plate'] = licence_plate;
    if (friendly_name !== undefined) body['friendly_name'] = friendly_name;
    if (rate_class !== undefined) body['rate_class'] = rate_class;

    return httpPost(carsUrl, body, signal);
};

const getCars = async (page, pageSize, sort = 'number', signal) => {
    let allUrl = `${carsUrl}?page=${page}&per_page=${pageSize}&sort=${sort}`;

    return httpGet(allUrl, signal);
};

const getCar = async (carID, signal) => {
    let singleCarUrl = `${carsUrl}/${carID}`;

    return httpGet(singleCarUrl, signal);
};

const updateCar = async (carID, {vin, make, model, year, seats, colour, number, licence_plate, friendly_name, rate_class}, signal) => {
    const updateURL = `${carsUrl}/${carID}`;

    const body = {};

    if (vin !== undefined) body['vin'] = vin;
    if (make !== undefined) body['make'] = make;
    if (model !== undefined) body['model'] = model;
    if (year !== undefined) body['year'] = year;
    if (seats !== undefined) body['seats'] = seats;
    if (colour !== undefined) body['colour'] = colour;
    if (number !== undefined && number !== null) body['number'] = number;
    if (licence_plate !== undefined) body['licence_plate'] = licence_plate;
    if (friendly_name !== undefined) body['friendly_name'] = friendly_name;
    if (rate_class !== undefined) body['rate_class'] = rate_class;

    return await httpPut(updateURL, body, signal);
};

//endregion
//region link/unlink Accessories

/**
 *
 * @param carID         int
 * @param accessoriesID  array
 * @param signal
 */
const syncAccessories = async (carID, accessoriesID, signal) => {
    const syncAccessoriesUrl = `${carsUrl}/${carID}/sync_accessories`;

    const body = {
        'accessories': accessoriesID,
    };

    return await httpPost(syncAccessoriesUrl, body, signal);
}

//endregion

const updateCarStatus = ({status, type, startedAt, endedAt}, id, signal) => {
    const carStatusUrl = `${carsUrl}/${id}/status`;

    const body = {
        name: status.toLowerCase(),
        type,
        started_at: formatTimestampWithoutSeconds(startedAt),
        id,
    };

    if (endedAt) {
        body['ended_at'] = formatTimestampWithoutSeconds(endedAt);
    }

    return httpPost(carStatusUrl, body, signal);
};

const getCarsLocations = async (page, pageSize, sort = 'number', signal) => {
    let startedAt = formatTimestamp(dayjs());
    let endedAt = formatTimestamp(dayjs().add(1, 'seconds'));

    startedAt = encodeURIComponent(startedAt);
    endedAt = encodeURIComponent(endedAt);
    const carsLocationsUrl = `${carsUrl}/cars_and_locations?page=${page}&per_page=${pageSize}&started_at=${startedAt}&ended_at=${endedAt}&sort=${sort}`;

    return httpGet(carsLocationsUrl, signal);
};

const getCarBookings = (carID, startedAt, endedAt, page, perPage, signal) => {
    startedAt = encodeURIComponent(startedAt);
    endedAt = encodeURIComponent(endedAt);
    const carBookingsUrl = `${carsUrl}/${carID}/get_bookings?started_at=${startedAt}&ended_at=${endedAt}&page=${page}&per_page=${perPage}`;

    return httpGet(carBookingsUrl, signal);
};

const getCarHardware = async (carID, signal) => {
    const getCarHardwareUrl = `${carsUrl}/${carID}/get_hardware`;

    return await httpGet(getCarHardwareUrl, signal);
};

const getCarHardwareEvents = async (carID, {page = 1, perPage = 10, startedAt, endedAt}, signal) => {
    startedAt = startedAt ? formatDate(startedAt) : formatDate(dayjs().tz().subtract(1, 'years'));
    endedAt = endedAt ? formatDate(endedAt) : '';

    const getCarHardwareEvents = `${carsUrl}/${carID}/get_hardware_events?page=${page}&per_page=${perPage}&started_at_date=${startedAt}&ended_at_date=${endedAt}`;

    return await httpGet(getCarHardwareEvents, signal);
}

const getCarTrips = async (carID, {page = 1, perPage = 10}, signal) => {

    const getCarHardwareTrips = `${carsUrl}/${carID}/get_trips?page=${page}&per_page=${perPage}`;

    return await httpGet(getCarHardwareTrips, signal);
}

const createCarImage = async (carID, file, signal) => {
    const createCarImageUrl = `${carsUrl}/${carID}/upload_image`;

    const formData = new FormData();
    formData.append('image', file);

   return await httpPostFile(createCarImageUrl, formData, signal);
}

const deleteCarImage = async (carID, signal) => {
    const carImageDeleteURL = `${carsUrl}/${carID}/delete_image`;

    return httpDelete(carImageDeleteURL, signal);
}

export {
    addCar,
    buildCarDescription,
    createCarImage,
    deleteCarImage,
    getCars,
    getCar,
    updateCar,
    getCarsLocations,
    updateCarStatus,
    getCarBookings,
    getCarHardware,
    getCarHardwareEvents,
    getCarTrips,
    syncAccessories,
    colours,
};
